export default __webpack_public_path__ + "static/media/serpentines_2_lowdef.697cf888.png";